import React from 'react';
import { motion } from 'framer-motion';

const Maintenance = () => {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            color: 'white',
            textAlign: 'center',
            padding: '20px',
            fontFamily: "'Inter', sans-serif"
        }}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <div style={{
                    fontSize: '80px',
                    marginBottom: '20px'
                }}>
                    🛠️
                </div>
                <h1 style={{
                    fontSize: '3rem',
                    fontWeight: '800',
                    marginBottom: '1rem',
                    background: 'linear-gradient(to right, #60a5fa, #a78bfa)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Under Maintenance
                </h1>
                <p style={{
                    fontSize: '1.25rem',
                    color: '#94a3b8',
                    maxWidth: '600px',
                    lineHeight: '1.6',
                    marginBottom: '2rem'
                }}>
                    We're currently performing some scheduled maintenance to improve our services. 
                    We'll be back online shortly. Thank you for your patience!
                </p>
                <div style={{
                    display: 'flex',
                    gap: '15px',
                    justifyContent: 'center'
                }}>
                </div>
            </motion.div>
            
            <div style={{
                position: 'absolute',
                bottom: '40px',
                fontSize: '0.9rem',
                color: '#64748b'
            }}>
                &copy; {new Date().getFullYear()} ReferMe. All rights reserved.
            </div>
        </div>
    );
};

export default Maintenance;
